import React, { useState, useEffect } from 'react';
import classes from "./Leaderboard2.module.css";
import { monthlyLeaderboardApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Header2 from '../../component/NewComponents/Header2';
import { useTranslation } from 'react-i18next';

const Leaderboard2 = () => {
    const [type, setType] = useState("fantasy");
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [fantasyLeaderboard, setFantasyLeaderboard] = useState([]);
    const [predictionLeaderboard, setPredictionLeaderboard] = useState([]);

    const {t}=useTranslation();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);
            const response = await monthlyLeaderboardApi(userDetails?.token);
            setFantasyLeaderboard(response?.data?.fantasy);
            setPredictionLeaderboard(response?.data?.prediction);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                toast.error(t("20"));
            }
        }
    };

    useEffect(() => { fetchLeaderboard(); }, []);

    const activeList = type === "fantasy" ? fantasyLeaderboard : predictionLeaderboard;

    const rankEmoji = (rank) => {
        if (rank == 1) return "🥇";
        if (rank == 2) return "🥈";
        if (rank == 3) return "🥉";
        return rank;
    };

    return (
        <div className={classes.page}>
            <Header2 active={3} />

            <main className={classes.main}>

                {/* Hero bar */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>{t("154")}</span>
                        <h1 className={classes.heroTitle}>{t("155")}<em>{t("156")}</em></h1>
                        {/* <h1 className={classes.heroTitle}>{t("157")}</h1> */}
                    </div>
                </div>

                {/* Type toggle */}
                <div className={classes.tabs_container}>
                    <button
                        type="button"
                        className={`${classes.tab_option} ${type === "fantasy" ? classes.active : ''}`}
                        onClick={() => setType("fantasy")}
                    >
                        ⚽ {t("158")}
                    </button>
                    <button
                        type="button"
                        className={`${classes.tab_option} ${type === "predict" ? classes.active : ''}`}
                        onClick={() => setType("predict")}
                    >
                        🎯 {t("159")} &amp; {t("160")}
                    </button>
                </div>

                {/* Content */}
                {loading ? (
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                    </div>
                ) : (
                    <div className={classes.leaderboard_container}>
                        <div className={classes.headings}>
                            <div className={classes.rank_heading}>{t("161")}</div>
                            <div className={classes.number_heading}>{t("162")}</div>
                            <div className={classes.points_heading}>{t("163")}</div>
                        </div>
                        {activeList?.map((data, index) => (
                            <div className={classes.leaderboard_data} key={index}>
                                <div className={classes.rank_data}>{rankEmoji(data?.rank)}</div>
                                <div className={classes.number_data}>{data?.msisdn}</div>
                                <div className={classes.points_data}>{data?.total_points}</div>
                            </div>
                        ))}
                    </div>
                )}

            </main>
        </div>
    );
};

export default Leaderboard2;